<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
             <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
        </div>
        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-4 mb-6 mb-lg-0">
                    <h1 class="text-white font-weight-light">Business Scenarios</h1>
                    <p class="lead text-white mt-4">Magicom aims to solve critical chanllenges facing by enterprises under diverse business scenarios including marketing, manufacturing, transportation, robotics, finance, medication, agriculture, entertainment etc.</p>
                </div>
                <div class="col-lg-8 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <b-carousel-slide img-src="img/marketing.png">
                                <h5 style="color:#ffffff;">Marketing</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/manufacturing.png">
                                <h5 style="color:#ffffff;">Manufacturing</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/transportation.png">
                                <h5 style="color:#ffffff;">Transportation</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/robotics.png">
                                <h5 style="color:#ffffff;">Robotics</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/finance.png">
                                <h5 style="color:#ffffff;">Finance</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/medical.png">
                                <h5 style="color:#ffffff;">Medication</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/agriculture.png">
                                <h5 style="color:#ffffff;">Agriculture</h5>
                            </b-carousel-slide>
                            <b-carousel-slide img-src="img/entertainment.png">
                                <h5 style="color:#ffffff;">Entertainment</h5>
                            </b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
